export const NotificationTypes = [
  { ui_name: "Active", machine_name: "Active" },
  { ui_name: "Archived", machine_name: "Archived" },
];
